/**
 * CL Search Collections
 *
 * Shopify no incluye colecciones en search.results. Esta sección consulta
 * /collections.json, filtra el catálogo público y pagina sus resultados de
 * forma independiente a la paginación de productos.
 */
(function () {
  var SECTION_TYPE = "cl-search-collections";
  var CATALOG_PAGE_SIZE = 250;
  var MAX_CATALOG_PAGES = 20;
  var imageCache = Object.create(null);

  function normalize(value) {
    return String(value || "").normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().trim();
  }

  function stripHtml(value) {
    var node = document.createElement("div");
    node.innerHTML = value || "";
    return node.textContent || "";
  }

  function tokenMatches(haystack, token) {
    if (haystack.indexOf(token) !== -1) return true;
    if (token.length > 3 && token.slice(-1) === "s" && haystack.indexOf(token.slice(0, -1)) !== -1) return true;
    return token.length > 4 && token.slice(-2) === "es" && haystack.indexOf(token.slice(0, -2)) !== -1;
  }

  function collectionMatches(collection, terms) {
    var tokens = normalize(terms).split(/\s+/).filter(Boolean);
    var searchable = normalize([collection.title, collection.handle, stripHtml(collection.description)].join(" "));
    return tokens.length > 0 && tokens.every(function (token) { return tokenMatches(searchable, token); });
  }

  function fetchCatalog(page, collections) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
    var url = root + "collections.json?limit=" + CATALOG_PAGE_SIZE + "&page=" + page;
    return fetch(url, { credentials: "same-origin", cache: "no-store" })
      .then(function (response) {
        if (!response.ok) throw new Error("HTTP " + response.status + " al cargar " + url);
        return response.json();
      })
      .then(function (payload) {
        var pageCollections = payload.collections || [];
        var allCollections = collections.concat(pageCollections);
        return pageCollections.length === CATALOG_PAGE_SIZE && page < MAX_CATALOG_PAGES
          ? fetchCatalog(page + 1, allCollections)
          : allCollections;
      });
  }

  function collectionUrl(handle) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
    return root + "collections/" + encodeURIComponent(handle);
  }

  function getCollectionImage(collection) {
    if (collection.image && collection.image.src) return Promise.resolve(collection.image.src);
    if (Object.prototype.hasOwnProperty.call(imageCache, collection.handle)) return Promise.resolve(imageCache[collection.handle]);
    return fetch(collectionUrl(collection.handle) + "/products.json?limit=1", { credentials: "same-origin", cache: "force-cache" })
      .then(function (response) { return response.ok ? response.json() : { products: [] }; })
      .then(function (payload) {
        var product = payload.products && payload.products[0];
        var image = product && product.images && product.images[0] ? product.images[0].src : "";
        imageCache[collection.handle] = image;
        return image;
      })
      .catch(function () { imageCache[collection.handle] = ""; return ""; });
  }

  function createCollectionCard(collection) {
    var card = document.createElement("a");
    card.className = "cl-search-collection-card";
    card.href = collectionUrl(collection.handle);
    var imageWrapper = document.createElement("span");
    imageWrapper.className = "cl-search-collection-card__image-wrapper";
    var image = document.createElement("img");
    image.className = "cl-search-collection-card__image";
    image.alt = "";
    image.loading = "lazy";
    image.hidden = true;
    imageWrapper.appendChild(image);
    getCollectionImage(collection).then(function (src) { if (src) { image.src = src; image.hidden = false; } });
    var badge = document.createElement("span");
    badge.className = "cl-search-collection-card__badge";
    badge.textContent = String(collection.products_count || 0);
    imageWrapper.appendChild(badge);
    var title = document.createElement("span");
    title.className = "cl-search-collection-card__title";
    title.textContent = collection.title;
    card.appendChild(imageWrapper);
    card.appendChild(title);
    return card;
  }

  function paginationParts(currentPage, pageCount) {
    var pages = [];
    var previous = null;
    for (var page = 1; page <= pageCount; page += 1) {
      if (page === 1 || page === pageCount || Math.abs(page - currentPage) <= 1) {
        if (previous !== null && page - previous > 1) pages.push("ellipsis-" + page);
        pages.push(page);
        previous = page;
      }
    }
    return pages;
  }

  function pageHref(page) {
    var url = new URL(window.location.href);
    url.searchParams.set("collections_page", page);
    return url.pathname + url.search + url.hash;
  }

  function createArrow(direction) {
    var arrow = document.createElement("span");
    arrow.setAttribute("aria-hidden", "true");
    arrow.textContent = direction === "previous" ? "‹" : "›";
    return arrow;
  }

  function renderPagination(container, state) {
    var target = container.querySelector("[data-cl-search-collections-pagination]");
    target.innerHTML = "";
    if (state.pageCount <= 1) return;
    var pagination = document.createElement("nav");
    pagination.className = "pagination cl-pagination";
    pagination.setAttribute("aria-label", container.getAttribute("data-goto-label") || "Paginación");
    var inner = document.createElement("div");
    inner.className = "pagination__inner";

    function addPreviousNext(direction) {
      var isPrevious = direction === "previous";
      var enabled = isPrevious ? state.currentPage > 1 : state.currentPage < state.pageCount;
      var element = document.createElement(enabled ? "a" : "span");
      element.className = "pagination__" + (isPrevious ? "prev" : "next") + (enabled ? " link" : " is-disabled");
      if (enabled) {
        var page = state.currentPage + (isPrevious ? -1 : 1);
        element.href = pageHref(page);
        element.setAttribute("data-collection-page", page);
      } else {
        element.setAttribute("aria-disabled", "true");
      }
      var label = container.getAttribute(isPrevious ? "data-previous-text" : "data-next-text") || (isPrevious ? "Anterior" : "Siguiente");
      if (isPrevious) element.appendChild(createArrow(direction));
      if (container.getAttribute("data-show-prev-next-text") !== "false") {
        element.appendChild(document.createTextNode((isPrevious ? " " : "") + label + (isPrevious ? "" : " ")));
      }
      if (!isPrevious) element.appendChild(createArrow(direction));
      inner.appendChild(element);
    }

    addPreviousNext("previous");
    var nav = document.createElement("span");
    nav.className = "pagination__nav";
    paginationParts(state.currentPage, state.pageCount).forEach(function (part) {
      if (typeof part === "string") {
        var ellipsis = document.createElement("span");
        ellipsis.className = "pagination__nav-item";
        ellipsis.textContent = "…";
        nav.appendChild(ellipsis);
        return;
      }
      var pageElement = document.createElement(part === state.currentPage ? "span" : "a");
      pageElement.className = "pagination__nav-item" + (part === state.currentPage ? " is-active" : " link");
      pageElement.textContent = String(part);
      if (part === state.currentPage) pageElement.setAttribute("aria-current", "page");
      else { pageElement.href = pageHref(part); pageElement.setAttribute("data-collection-page", part); }
      nav.appendChild(pageElement);
    });
    inner.appendChild(nav);
    addPreviousNext("next");

    var pageCount = document.createElement("span");
    pageCount.className = "pagination__page-count";
    var pageCountTemplate = container.getAttribute("data-page-count-text") || "Página __PAGE__ / __PAGES__";
    pageCount.textContent = pageCountTemplate.replace("__PAGE__", state.currentPage).replace("__PAGES__", state.pageCount);
    inner.appendChild(pageCount);

    if (container.getAttribute("data-show-goto") !== "false") {
      var form = document.createElement("form");
      form.className = "pagination__goto";
      form.setAttribute("data-cl-collections-pagination-goto", "");
      var input = document.createElement("input");
      input.type = "number";
      input.inputMode = "numeric";
      input.className = "pagination__goto-input";
      input.min = "1";
      input.max = String(state.pageCount);
      input.step = "1";
      input.value = String(state.currentPage);
      input.setAttribute("aria-label", container.getAttribute("data-goto-label") || "Ir a la página");
      var submit = document.createElement("button");
      submit.type = "submit";
      submit.className = "pagination__goto-submit";
      submit.textContent = container.getAttribute("data-goto-text") || "Ir";
      form.appendChild(input);
      form.appendChild(submit);
      inner.appendChild(form);
    }
    pagination.appendChild(inner);
    target.appendChild(pagination);
  }

  function init(container) {
    if (!container || container.hasAttribute("data-cl-search-collections-initialized")) return;
    container.setAttribute("data-cl-search-collections-initialized", "true");
    var terms = container.getAttribute("data-search-terms");
    var resultsElement = container.querySelector("[data-cl-search-collections-results]");
    if (!terms || !resultsElement) return;
    var state = {
      currentPage: Math.max(1, parseInt(new URL(window.location.href).searchParams.get("collections_page"), 10) || 1),
      pageCount: 0,
      pageSize: Math.max(1, parseInt(container.getAttribute("data-items-per-page"), 10) || 10),
      results: []
    };

    function render(shouldScroll) {
      state.pageCount = Math.max(1, Math.ceil(state.results.length / state.pageSize));
      state.currentPage = Math.min(Math.max(1, state.currentPage), state.pageCount);
      var start = (state.currentPage - 1) * state.pageSize;
      resultsElement.innerHTML = "";
      state.results.slice(start, start + state.pageSize).forEach(function (collection) {
        resultsElement.appendChild(createCollectionCard(collection));
      });
      renderPagination(container, state);
      if (shouldScroll) container.scrollIntoView({ behavior: "smooth", block: "start" });
    }

    container.addEventListener("click", function (event) {
      var link = event.target.closest("[data-collection-page]");
      if (!link) return;
      event.preventDefault();
      state.currentPage = parseInt(link.getAttribute("data-collection-page"), 10) || 1;
      window.history.replaceState({}, "", pageHref(state.currentPage));
      render(true);
    });

    container.addEventListener("submit", function (event) {
      var form = event.target.closest("[data-cl-collections-pagination-goto]");
      if (!form) return;
      event.preventDefault();
      var input = form.querySelector(".pagination__goto-input");
      state.currentPage = Math.min(state.pageCount, Math.max(1, parseInt(input.value, 10) || 1));
      window.history.replaceState({}, "", pageHref(state.currentPage));
      render(true);
    });

    fetchCatalog(1, []).then(function (collections) {
      state.results = collections.filter(function (collection) { return collectionMatches(collection, terms); })
        .sort(function (a, b) {
          return a.title.localeCompare(b.title, document.documentElement.lang || "es", {
            sensitivity: "base",
            numeric: true
          });
        });
      if (!state.results.length) return;
      container.classList.add("is-visible");
      document.querySelectorAll("[data-cl-search-empty-state]").forEach(function (emptyState) { emptyState.style.display = "none"; });
      render(false);
    }).catch(function (error) {
      console.warn("[cl-search-collections] No se pudo cargar el catálogo:", error);
    });
  }

  function initAll() {
    document.querySelectorAll('[data-section-type="' + SECTION_TYPE + '"]').forEach(init);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", initAll);
  else initAll();

  document.addEventListener("shopify:section:load", function (event) {
    var selector = '[data-section-type="' + SECTION_TYPE + '"]';
    var container = event.target.matches && event.target.matches(selector) ? event.target : event.target.querySelector(selector);
    if (container) { container.removeAttribute("data-cl-search-collections-initialized"); init(container); }
  });
})();
